import React, { type ReactNode } from "react";
import { Box, Stack, Typography } from "@mui/material";
import {
  publicInfoEyebrowSx,
  publicInfoHeaderAccentSx,
  publicInfoPageIntroSx,
  publicInfoPageTitleSx
} from "./constants/publicInfoPageStyles";

type PublicInfoPageHeaderProps = {
  title: string;
  intro?: ReactNode;
  eyebrow?: string;
  /** Sets `data-testid` on the page title, e.g. `about-page-title`. */
  pageTestId?: string;
};

const PublicInfoPageHeader: React.FC<PublicInfoPageHeaderProps> = ({
  title,
  intro,
  eyebrow,
  pageTestId
}) => (
  <Stack spacing={1.5} alignItems="center" sx={{ mb: { xs: 2.5, sm: 3 } }}>
    {eyebrow ? (
      <Typography component="p" sx={publicInfoEyebrowSx}>
        {eyebrow}
      </Typography>
    ) : null}
    <Typography
      component="h1"
      variant="h4"
      sx={publicInfoPageTitleSx}
      data-testid={pageTestId ? `${pageTestId}-title` : undefined}
    >
      {title}
    </Typography>
    <Box sx={publicInfoHeaderAccentSx} aria-hidden />
    {intro ? (
      <Box component="p" sx={{ ...publicInfoPageIntroSx, m: 0, mt: 0.5 }}>
        {intro}
      </Box>
    ) : null}
  </Stack>
);

export default PublicInfoPageHeader;
